import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Button, Input, UncontrolledTooltip, Badge } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import * as be from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';

import * as url from "helpers/url_helper"
import { useHistory } from 'react-router-dom';

import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'

    const WorkOrders = () => {

        toastr.options = TOAST_OPTIONS;
        const history = useHistory()
        const [modal_request, setmodal_request] = useState(false)
        const [isEdit, setIsEdit] = useState(false)
        const [dataList, setDataList] = useState([])
        const [isLoading, setIsLoading] = useState(false)
        const [facilityId, setFacilityId] = useState('')
        const [request, setRequest] = useState('')
        const [requestedBy, setRequestedBy] = useState('')
        const [requestedByName, setRequestedByName] = useState('')
        const [dateTimeRequested, setDateTimeRequested] = useState('')
        const [requestId, setRequestId] = useState('')
        const [selectedDates, setSelectedDates] = useState([new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),new Date()])

        const [sJobNo, setSJobNo]      = useState('')
        const [sDate, setSDate]         = useState([new Date()])
        const [eDate, setEDate]         = useState([new Date()])
        const [sRegion, setSRegion]      = useState('')
        const [sCluster, setSCluster]    = useState('')
        const [sArea, setSArea]         = useState('')
        const [sScheme, setSScheme]     = useState('')
        const [sFacility, setSFacility] = useState('')
        const [sStatus, setSStatus]     = useState('')
        const [sMaintenanceType, setSMaintenanceType] = useState('')
        const [sTaskType, setSTaskType] = useState('')
        const [sPriority, setSPriority]     = useState('')
        const [sAsset, setSAsset]     = useState('')
        const [sStaff, setSStaff]     = useState('')
        const [sMine, setSMine]         = useState('')
        const [userId, setUserId]       = useState('')
        const [selectedPriority, setSelectedPriority] = useState('')
        const [selectedTaskType, setSelectedTaskType] = useState('')
        const [selectedMaintenanceType, setSelectedMaintenanceType] = useState('')
        
        const [statusOptions, setStatusOptions] = useState(['Open', 'Pending Approval', 'Closed'])
        const [trade, setTrades] = useState(['Electrical','Mechanical','Civil','Automotive','Plumbing','General'])
        const [maintenanceTypes, setMaintenanceTypes] = useState(['Planned','Unplanned'])
        const [taskTypes, setTaskTypes] = useState(['Corrective','Breakdown','Service','Installation','Modification','PPM'])
        const [priority, setPriority] = useState(['High','Medium','Low'])
        const [assigns, setAssigns] = useState([])

        const [regions, setRegions] = useState([]);
        const [clusters, setClusters] = useState([]);
        const [areas, setAreas] = useState([]);
        const [schemes, setSchemes] = useState([]);
        const [facilities, setFacilities] = useState([]);
        const [assets, setAssets] = useState([]);

        
        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
        const tog_request = () => {
          fetchData()
          setmodal_request(!modal_request)
          removeBodyCss()
        }
        const clearData = () =>{
          setFacilityId('')
          setRequest('')
          setDateTimeRequested('')
        }
        const handleShowWR = (row) =>{
          setIsEdit(true); 
          setRequestId(row.id); 
          setFacilityId(row.facilityId); 
          setRequest(row.details); 
          setDateTimeRequested(row.dateTime); 
          setRequestedByName(row.requestedByName); 
          tog_request();
        }
        const handleFilterData = () =>{
            const data = {
              id      : '',
              card    : sJobNo,
              sDate   : formatDate(sDate),
              eDate   : formatDate(eDate),
              status  : sStatus,
              region  : sRegion,
              cluster : sCluster,
              area    : sArea,
              scheme  : sScheme,
              facilityId: sFacility,
              status  : sStatus,
              mType   : selectedMaintenanceType,
              tType   : selectedTaskType,
              priority: selectedPriority,
              staff   : sStaff,
              mine    : sMine
            }
            setIsLoading(true)
            axios.post(url.WORDERSFILTER, JSON.stringify(data), Config).then((r)=>{
              setDataList(r.data)
              //console.log(r.data)
              setIsLoading(false)
            }).catch((e)=>{
              console.log(e)
              setIsLoading(false)
            })
        }
        const fetchData = () => {
          if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"))
            setUserId(obj.id)
          }
          axios.get(url.REGIONS, Config).then((r)=>{ setRegions(r.data); }).catch((e)=>{  console.log(e); });
          axios.get(url.CLUSTERS, Config).then((r)=>{ setClusters(r.data); }).catch((e)=>{  console.log(e); });
          axios.get(url.AREAS, Config).then((r)=>{ setAreas(r.data); }).catch((e)=>{  console.log(e); });
          axios.get(url.SCHEME, Config).then((r)=>{ setSchemes(r.data); }).catch((e)=>{  console.log(e); });
          axios.get(url.FACILITIES, Config).then((r)=>{ setFacilities(r.data) }).catch((e)=>{ console.log(e) })
          axios.get(url.USERS, Config).then((r)=>{setAssigns(r.data); }).catch((e)=>{ console.log(e) })
          axios.post(url.ASSETSFILTER, Config).then((r)=>{ console.log(r) }).catch((e)=>{ console.log(e) })
          handleFilterData()
        }

        useEffect(() => {
         fetchData();
        },[]);
      
        const getClusters = (u) =>{
          axios.get(`${url.CLUSTERS}?region?${u}`, Config).then((r)=>{ setClusters(r.data); }).catch((e)=>{  console.log(e); });
        }
        const getAreas = (c) =>{
          axios.get(`${url.AREAS}?cluster?${c}`, Config).then((r)=>{ setAreas(r.data); }).catch((e)=>{  console.log(e); });
        }
        const getSchemes = (a) =>{
          axios.get(`${url.SCHEME}?area?${a}`, Config).then((r)=>{ setSchemes(r.data) }).catch((e)=>{ console.log(e) })
        }
        const getFacilities = (s) =>{
          axios.get(`${url.FACILITIES}?scheme?${s}`, Config).then((r)=>{ setFacilities(r.data) }).catch((e)=>{ console.log(e) })
        }
 
        const { SearchBar } = Search;
        const columns = [
          {
            dataField: "",
            isDummyField: true,
            text: "",
            formatter: cardFormatter
          },
        {
            dataField: 'card',
            text: 'Job number',
            sort: true
        },
       /* {
          dataField: 'areaName',
          text: 'Area',
          sort: true
        },
        {
          dataField: 'facilityName',
          text: 'Facility',
          sort: true
        },
        */
        {
          dataField: 'title',
          text: 'Description',
          sort: true
        },
        {
          dataField: 'assignedOn',
          text: 'Assigned On',
          sort: true
      },
        {
          dataField: 'workStatus',
          text: 'Status',
          sort: true,
          formatter: statusFormatter
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'assignedOn',
          order: 'desc'
        }];
        function cardFormatter(cellContent, row) {
          if (row.priority == "High") {
            return (
              <><i className="bx bx-caret-right font-size-20 text-danger align-middle ms-2" />{ cellContent }</>
            );
          }else if (row.priority == "Medium"){
            return (
              <><i className="bx bx-caret-right  font-size-16 text-warning align-middle ms-2" />{ cellContent }</>
            );
          }else{
            return (
              <><i className="bx bx-caret-right  font-size-16 text-dark align-middle ms-2" />{ cellContent }</>
            );
          }
        }
        function statusFormatter(cellContent, row) {
          if (row.workStatus == "Open") {
            return (
              <div>
                  <Badge className="me-2 bg-danger">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else if (row.workStatus == "Closed"){
              return (
                <div>
                    <Badge className="me-2 bg-success">
                    { cellContent }
                    </Badge>
                </div>
              );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-warning">
                  { cellContent }
                  </Badge>
              </div>
            );
          }
        }
        function actionFormatter(cellContent, row){
          return(
            <>
                <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  onClick={()=>{ history.push(`/WorkOrder-Details/${be.encryptId(row.id)}`) }}
                >
                  Details
                </Button>
          </>
          )
        }

        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Work Orders | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        
           
                      <Row>             
                        <Col lg="12">
                        <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                                <CardBody>
                                <div>
                                    <Row className="justify-content-center mb-2">
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Jobcard number</label>
                                                          <input type='text' className="form-control form-control-sm" value={sJobNo} onChange={(e)=>setSJobNo(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>From</label>
                                                          <Flatpickr
                                                            className="form-control form-control-sm"
                                                            options={{
                                                                dateFormat: "Y-m-d",
                                                                enableTime: false
                                                            }}
                                                            value={sDate}
                                                            onChange={(dates)=>setSDate(dates)}
                                                            />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Till </label>
                                                          <Flatpickr
                                                              className="form-control form-control-sm"
                                                              options={{
                                                                  dateFormat: "Y-m-d",
                                                                  enableTime: false
                                                              }}
                                                              value={eDate}
                                                              onChange={(dates)=>setEDate(dates)}
                                                              />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Status</label>
                                                          <select className="form-select form-select-sm" value={sStatus} onChange={(e)=>setSStatus(e.target.value)}>
                                                          <option value=""></option>
                                                              {statusOptions.map((s,k)=>(
                                                                  <option value={s} key={k}>{s}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                 {/* <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Region</label>
                                                          <select className="form-select form-select-sm" value={sRegion} onChange={(e)=>{setSRegion(e.target.value); getClusters(e.target.value); setSCluster(''); setSArea(''); setSScheme(''); setSFacility('')}}>
                                                          <option value=""></option>
                                                              {regions.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.region}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Cluster</label>
                                                          <select className="form-select form-select-sm" value={sCluster} onChange={(e)=>{setSCluster(e.target.value); getAreas(e.target.value); setSArea(''); setSScheme(''); setSFacility('')}}>
                                                          <option value=""></option>
                                                              {clusters.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.cluster}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Area</label>
                                                          <select className="form-select form-select-sm" value={sArea} onChange={(e)=>{setSArea(e.target.value); getSchemes(e.target.value);  setSScheme(''); setSFacility('')}}>
                                                          <option value=""></option>
                                                              {areas.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.name}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Scheme</label>
                                                          <select className="form-select form-select-sm" value={sScheme} onChange={(e)=>{setSScheme(e.target.value); getFacilities(e.target.value); setSFacility('')}}>
                                                          <option value=""></option>
                                                              {schemes.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.scheme}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  */}
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Facility</label>
                                                          <select className="form-select form-select-sm" value={sFacility} onChange={(e)=>setSFacility(e.target.value)}>
                                                          <option value=""></option>
                                                              {facilities.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.facility}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Asset</label>
                                                          <select className="form-select form-select-sm" value={sAsset} onChange={(e)=>setSAsset(e.target.value)}>
                                                          <option value=""></option>
                                                              {assets.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.asset}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                      <label>Maintenance type</label>
                                                      <select className="form-select form-select-sm" value={selectedMaintenanceType} onChange={(e)=>setSelectedMaintenanceType(e.target.value)}>
                                                      <option value=''></option>
                                                          {maintenanceTypes.map((t,k)=>(
                                                              <option key={k} value={t}>{t}</option>
                                                          ))}
                                                      </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                      <label>Task type</label>
                                                      <select className="form-select form-select-sm" value={selectedTaskType} onChange={(e)=>setSelectedTaskType(e.target.value)} >
                                                          <option value=""></option>
                                                          {taskTypes.map((t,k)=>(
                                                              <option key={k} value={t}>{t}</option>
                                                          ))}
                                                      </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                      <label>Priority</label>
                                                      <select className="form-select form-select-sm" value={selectedPriority} onChange={(e)=>setSelectedPriority(e.target.value)} >
                                                      <option value=''></option>
                                                          {priority.map((t,k)=>(
                                                              <option key={k} value={t}>{t}</option>
                                                          ))}
                                                      </select>
                                                      </div>
                                                  </Col>
                                                  
                            
                                      
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Job assigned to:</label>
                                                          <select className="form-select form-select-sm" value={sStaff} onChange={(e)=>setSStaff(e.target.value)}>
                                                              <option value=""></option>
                                                              {assigns.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.name}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Jobs assigned to me</label>
                                                          <select className="form-select form-select-sm" value={sMine} onChange={(e)=>{setSMine(e.target.value)}}>
                                                              <option value={``}></option>
                                                              <option value="">List all Jobs</option>
                                                              <option value={userId}>List Jobs assigned to me</option>
                                                          </select>
                                                          
                                                      </div>
                                                  </Col>
                                                  
                                     
                                                  
                                                </Row>
                                                <Row  className="justify-content-center mb-2">
                                                <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='warning'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClearSearch()}}
                                                      >
                                                        <i className="mdi mdi-notification-clear-all me-1" />
                                                        Reset search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        onClick={()=>{ history.push('Work-Requests') }}
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Raise work request
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                </div>
                                </CardBody>
                          </Card>
                        </Col>
                        <Col lg="12">

                            {dataList && (dataList.length > 0) && (
                                <>
                                
                                <ToolkitProvider
                                      keyField="id"
                                      data={ dataList }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                         
                                          <Card>
                                          <h5 className="card-header bg-transparent border-bottom text-uppercase">Maintenance Work orders</h5>
                                            <CardBody>
                                              
                           
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={ dataList } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                          </CardBody>
                                        </Card>
                                      </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>


                                </>
                            )}
                            
                            {dataList && (dataList.length < 1) && (
                              <Card>
                              <h5 className="card-header bg-transparent border-bottom text-uppercase">Maintenance Work orders</h5>
                                <CardBody>
                                        <div className="text-center">
                                            <div className="mb-4">
                                            <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                            </div>
                                            <div>
                                            <h5>No Work order Found</h5>
                                            <p className="text-muted">
                                                    
                                            </p>
                                            </div>
                                        </div>
                                </CardBody>
                              </Card>
                            )}
                            
                         
                        </Col>
                    </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default WorkOrders;